import { _login, _register } from '@/services/Auth'
import * as type from './types'
import { setToken } from '@/services/Http'

const actions = {
  doLogin ({ commit }, data) {
    return new Promise((resolve, reject) => {
      _login(data).then(response => {
        if (!response.body.success) {
          reject(new Error(response.body.message))
        } else {
          commit(type.STORE_USER, response.body)
          setToken()
          resolve(response)
        }
      }, err => reject(err))
    }, 2000)
  },
  doSingup ({ commit }, data) {
    return new Promise((resolve, reject) => {
      _register(data).then(response => {
        commit(type.STORE_USER, {
          payload: response.body,
        })
        setToken()
        resolve(response)
      }, err => reject(err))
    })
  },
  checkToken ({ commit }) {
    setToken()
  },
  doLogout ({ commit }) {
    logoutUser(commit)
  },
  updateProfile ({ commit }, user) {
    commit(type.PROFILE_UPDATE, {
      payload: user,
    })
  },
}

let logoutUser = (commit) => {
  commit(type.LOGOUT)
}

export default actions
